import { between, down, only, up } from '@smart-tv/utils/breakpoints';
import { Theme } from 'typings/theme';

export const theme: Theme = {
  name: 'NORLYS',
  breakpoints: {
    values: {
      xs: 0,
      sm: 960,
      md: 1260,
      lg: 1320,
      xl: 1920
    },
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    up,
    down,
    between,
    only
  },
  components: {
    button: {
      borderRadius: '24px'
    }
  },
  palette: {
    background: {
      default: '#252525',
      primary: '#011224',
      secondary: '#273645',
      tertiary: '#414D5B',
      level1: '#303030',
      level2: '#ccc'
    },
    divider: '#9e9e9e',
    common: {
      white: '#f2f2f2',
      black: '#000'
    },
    error: {
      main: '#f44336',
      dark: '#d32f2f',
      secondary: '#FFDB38',
      contrastText: '#f2f2f2'
    },
    grey: {
      light: '#9b9b9b',
      main: '#505050',
      dark: '#303030'
    },
    primary: {
      main: '#369993',
      dark: '#00C9A2',
      contrastText: '#000'
    },
    secondary: {
      main: '#755FFA',
      dark: '#8370F1',
      contrastText: '#000'
    },
    tertiary: {
      main: 'rgba(65, 77, 91, 0.8)'
    },
    royalblue: {
      main: '#002B6B',
      dark: '#3F82CF'
    },
    lightpurple: {
      main: '#E3E1FF',
      dark: '#E3E1FF'
    },
    red: {
      main: '#F8232D',
      dark: '#F84049'
    },
    success: {
      main: '#00C9A2',
      light: '#369993'
    },
    text: {
      primary: '#f2f2f2',
      primaryHover: '#f2f2f2',
      secondary: '#9B9B9B',
      secondaryHover: '#f2f2f2'
    }
  },
  shape: {
    borderRadius: {
      sm: 4,
      md: 8,
      lg: 12
    }
  },
  spacing: (value: number | string) => (typeof value === 'string' ? value : `${value * 4}px`),
  typography: {
    fontFamily: `${'Norlys'}, sans-serif`,
    spacing: {
      default: 0.7
    },
    weight: {
      light: 300,
      regular: 400,
      medium: 500,
      bold: 700
    },
    size: {
      sm: '12px',
      md: '14px',
      lg: '16px'
    },
    h1: {
      fontFamily: `${'Norlys Headline'}, sans-serif`,
      fontSize: '88px',
      lineHeight: '120px',
      fontWeight: 700
    },
    h2: {
      fontFamily: `${'Norlys Headline'}, sans-serif`,
      fontSize: '72px',
      lineHeight: '98px',
      fontWeight: 700
    },
    h3: {
      fontFamily: `${'Norlys Headline'}, sans-serif`,
      fontSize: '60px',
      fontWeight: 400,
      lineHeight: '84px'
    },
    h4: {
      fontFamily: `${'Norlys'}, sans-serif`,
      fontSize: '50px',
      fontWeight: 700,
      lineHeight: '70px'
    },
    h5: {
      fontFamily: `${'Norlys'}, sans-serif`,
      fontSize: '42px',
      fontWeight: 400,
      lineHeight: '56px'
    },
    h6: {
      fontFamily: `${'Norlys'}, sans-serif`,
      fontSize: '35px',
      fontWeight: 700,
      lineHeight: '49px'
    },
    body: {
      fontFamily: `${'Norlys'}, sans-serif`,
      fontSize: '32px',
      fontWeight: 400,
      lineHeight: '44px'
    },
    bodySmall: {
      fontFamily: `${'Norlys'}, sans-serif`,
      fontSize: '28px',
      fontWeight: 400,
      lineHeight: '39px'
    },
    caption: {
      fontFamily: `${'Norlys'}, sans-serif`,
      fontSize: '24px',
      fontWeight: 700,
      lineHeight: '35px'
    },
    caption2: {
      fontFamily: `${'Norlys'}, sans-serif`,
      fontSize: '22px',
      fontWeight: 400,
      lineHeight: '28px'
    },
    button: {
      fontFamily: `${'Norlys'}, sans-serif`,
      fontSize: '22px',
      fontWeight: 400,
      lineHeight: '28px'
    }
  },
  zIndex: {
    playerControls: 1250,
    dialog: 1300,
    overlay: 1400,
    tooltip: 1500
  }
};

export default theme;
